package com.milta.core.localization.translations.fr

import com.milta.core.localization.AdminOcrAnalysisStrings

internal val AdminOcrAnalysis = AdminOcrAnalysisStrings(
    loading = "Chargement…",
    errorNoConnection = "Impossible de contacter le serveur — vérifie ta connexion.",
    errorGeneric = "Une erreur est survenue. Réessaie plus tard.",
    emptyStateMessage = "Aucune donnée pour l'instant.",
    kpiTotalDocumentsLabel = "Documents analysés",
    kpiCompletedDocumentsLabel = "Documents complets",
    kpiCompletedDocumentsSubtitle = "simulés sur les 4 stratégies",
    kpiTotalRealCostLabel = "Coût réel total",
    kpiTotalInputTokensLabel = "Jetons d'entrée",
    kpiTotalOutputTokensLabel = "Jetons de sortie",
    breakdownByFileKindLabel = "Répartition",
    fileKindImageLabel = "Images",
    fileKindPdfLabel = "PDF",
    fileKindXlsxLabel = "Tableurs",
    flowTitle = "Le flux complet, étape par étape",
    flowYesLabel = "Oui",
    flowNoLabel = "Non",
    flowStep1Title = "Document envoyé",
    flowStep1Subtitle = "Photo, PDF ou fichier reçu via l'application",
    flowStep2Title = "Empreinte unique calculée",
    flowStep2Subtitle = "Un identifiant unique est calculé pour ce document",
    flowStep2Note = "Si déjà vu : l'analyse locale n'est pas refaite (le coût IA réel reste compté normalement, car c'est un vrai envoi).",
    flowStep3Title = "Type de fichier détecté",
    flowStep3Subtitle = "La suite de l'analyse diffère selon le type",
    flowImageBranchTitle = "📷 Si c'est une photo",
    flowImageStep1Title = "Vérification de la qualité",
    flowImageStep1Subtitle = "Netteté, luminosité, résolution, document bien cadré",
    flowImageStep2Title = "Si la qualité est jugée insuffisante",
    flowImageStep2Subtitle = "Le motif est journalisé, mais la lecture locale est quand même tentée juste après",
    flowImageStep3Title = "Correction d'inclinaison",
    flowImageStep3Subtitle = "L'image est redressée si une inclinaison fiable est détectée",
    flowImageStep4Title = "Lecture locale (gratuite)",
    flowImageStep4Subtitle = "Lecture du texte sans IA — français, néerlandais, anglais",
    flowImageStep5Title = "Score de fiabilité",
    flowImageStep5Subtitle = "Note de 0 à 100 sur la qualité de cette lecture locale",
    flowPdfBranchTitle = "📄 Si c'est un PDF",
    flowPdfStep1Title = "Texte natif détecté ?",
    flowPdfStep1Subtitle = "Vérifie si le PDF contient déjà du texte numérique exploitable",
    flowPdfNote = "Si scanné sans texte natif : chaque page (20 max) est transformée en image et relue localement comme une photo.",
    flowXlsxBranchTitle = "📊 Si c'est un tableur",
    flowXlsxStep1Title = "Colonnes identifiées",
    flowXlsxStep1Subtitle = "Reconnaissance automatique, ou via l'IA, des colonnes (nom, adresse, téléphone…)",
    flowXlsxNote = "Structure du fichier (lignes, colonnes, en-tête) analysée localement.",
    flowClaudeTitle = "Appel à l'IA (Claude)",
    flowClaudeSubtitle = "Dans tous les cas, un appel réel est fait aujourd'hui — coût facturé",
    flowSimulationTitle = "🔬 Simulation après coup (pas en production)",
    flowSimulationNote = "Une fois les données ci-dessus collectées, 4 stratégies alternatives sont rejouées sur ces mêmes documents pour estimer ce qu'elles auraient coûté à la place de l'appel systématique à l'IA — c'est exactement ce que compare le tableau ci-dessous. Aucune de ces 4 stratégies n'est utilisée en production aujourd'hui.",
    flowPersistTitle = "Sauvegarde",
    flowPersistSubtitle = "Le résultat réel et les 4 simulations sont enregistrés",
    flowDashboardTitle = "Tableau de bord",
    flowDashboardSubtitle = "Cet écran agrège les résultats par stratégie",
    tableTitle = "Comparaison des stratégies possibles",
    columnMode = "Stratégie",
    columnDocuments = "Documents",
    columnClaudeCalls = "Appels à l'IA",
    columnProjectedCost = "Coût projeté",
    columnRealCost = "Coût réel",
    columnSavings = "Économie projetée",
    modeBaseline = "Stratégie actuelle",
    modeBaselineDescription = "L'IA est appelée systématiquement pour chaque document — c'est ce qui est réellement utilisé aujourd'hui en production.",
    modeMinimal = "Prétraitement léger",
    modeMinimalDescription = "Petites optimisations avant l'envoi à l'IA, sans changer la décision : l'IA est toujours appelée, même coût que la stratégie actuelle.",
    modeTesseractGate = "Lecture locale avec relais IA",
    modeTesseractGateDescription = "Une lecture locale gratuite évalue d'abord la qualité du document ; l'IA n'est appelée que si cette lecture est jugée insuffisante.",
    modeTesseractOnly = "Lecture locale uniquement",
    modeTesseractOnlyDescription = "Aucun appel à l'IA — seulement une lecture locale gratuite, potentiellement moins fiable sur des documents de mauvaise qualité.",
)
